import { gql, useMutation } from "@apollo/client";
import type { IdeaBookItem } from "./types";

const UPDATE_IDEA_BOOK_ITEM_NOTE = gql`
  mutation UpdateIdeaBookItemNote($itemId: ID!, $note: String!) {
    updateIdeaBookItemNote(itemId: $itemId, note: $note) {
      _id
      ideaBookId
      homeownerId
      note
      createdAt
      updatedAt
      image {
        _id
        url
        path
        title
        description
        credit
      }
    }
  }
`;

type UpdateIdeaBookItemNoteData = {
  updateIdeaBookItemNote: IdeaBookItem;
};

type UpdateIdeaBookItemNoteVars = {
  itemId: string;
  note: string;
};

export const useUpdateIdeaBookItemNote = () => {
  const [updateIdeaBookItemNoteMutation, { loading, error, data }] = useMutation<
    UpdateIdeaBookItemNoteData,
    UpdateIdeaBookItemNoteVars
  >(UPDATE_IDEA_BOOK_ITEM_NOTE);

  const updateIdeaBookItemNote = async (args: UpdateIdeaBookItemNoteVars) => {
    const result = await updateIdeaBookItemNoteMutation({ variables: args });
    return result.data?.updateIdeaBookItemNote ?? null;
  };

  return { updateIdeaBookItemNote, loading, error, data };
};
